<template>
  <div class="container-fluid mt-2">
    <h2>Dashboard</h2>
    <b-tabs>
      <b-tab title="Dashboard">
        <div class="dashwidget" v-for="(w,idx) in widgets" :key="w.name" :style="'width:' + w.width + ';height:' + w.height">
          <DashToolbar :userid="userid" :widget="w" :index="idx"/>
          <iframe width="100%" :id="'widget' + idx" style="border: none;height:100%;" :src="'/dashboard/' + userid + '/' + encodeURIComponent(w.name) + '/index.html'">
          </iframe>
        </div>
      </b-tab>
      <b-tab title="Editor">
        <div role="toolbar" class="mt-2 btn-toolbar justify-content-between">
          <div class="btn-group">
            <button @click="saveWidgets" id="save" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
          </div>
          <div class="form-inline ml-2">
            <label>Berichtsvorlage:</label>
            <select v-model="basereport" class="form-control ml-2">
              <option v-for="r in reports" :key="r.id" :value="r.id">{{ r.name }}</option>
            </select>
            <button @click="addWidget" class="ml-2 btn btn-secondary"><font-awesome-icon icon="plus"/></button>
          </div>
        </div>
        <div id="widgets" class="wrapper">
          <div v-for="(w,idx) in widgets" :key="w.report" class="row mt-2 border p-2 ml-3 mr-3">
            <div class="col-md form-inline mr-3">
              <label>Bericht:</label>
              <label class="ml-2"><b>{{ w.name }}</b></label>
            </div>
            <div class="col-md form-inline ml-3">
              <label>Breite:</label>
              <input v-model="w.width" bind="width" class="form-control" type="text"/>
            </div>
            <div class="col-md form-inline ml-3">
              <label>Höhe:</label>
              <input bind="height" v-model="w.height" class="form-control" type="text"/>
            </div>
            <div class="col-md toolbar ml-3">
              <div class="btn-group">
                <button @click="remWidget(idx)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
                <button @click="moveUp(idx)"    class="btn btn-secondary"><font-awesome-icon icon="arrow-up"/></button>
                <button @click="moveDown(idx)"  class="btn btn-secondary"><font-awesome-icon icon="arrow-down"/></button>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import security from '@/modules/security.js'
import reports from '@/modules/reports.js'
import DashToolbar from '@/components/reports/DashToolbar.vue'

export default {
  name: 'Dashboard',
  components: {
    DashToolbar,
  },
  data() {
    return {
      reports: [],
      widgets: [],
      needs: ["if.proxy.dashboard","if.proxy.dashboard.root","if.reports.root"],
      config: {},
      basereport: "",
      baseurl: "/",
      userid: 1
    }
  },
  created: function() {
    var self = this;

    security.whoami().then(function(data) {
      console.log(data);
      self.userid = data.userid;
    })

    reports.list(function(data) {
      self.reports = data;
    })

    config.loadcfg(this.needs,this,function(data) {
      self.config = data;
      if (data['if.proxy.dashboard'].startsWith('[')) {
        self.widgets = JSON.parse(data['if.proxy.dashboard']);
      }
    })
  },
  methods: {
    addWidget: function() {
      console.log('add widget');
      console.log(this.basereport);
      var br = false;
      var self = this;
      this.reports.forEach(r => { if (r.id == self.basereport) br = r; })
      console.log(br);
      if (br) {
        var widget = { report: this.basereport, width: '100px',height: '100px',name: br.name ,params: br.params };
        this.widgets.push(widget);
      }
    },
    remWidget: function(idx) {
      this.widgets.splice(idx,1);
    },
    moveUp: function(idx) {
      if (idx <= 0) return;
      var item = this.widgets.splice(idx,1)[0];
      this.widgets.splice(idx-1,0,item);
      this.$forceUpdate();
      console.log('up');
    },
    moveDown: function(idx) {
      if (idx >= this.widgets.length) return;
      var item = this.widgets.splice(idx,1)[0];
      this.widgets.splice(idx+1,0,item);
    },
    saveWidgets: function() {
      console.log('save widgets');
      var data = {};var self = this;
      data['if.proxy.dashboard'] = JSON.stringify(this.widgets);
      config.savecfg(data,this,function() {
        self.$bvToast.toast('Dashboard gespeichert.',{title:'Dashboard',variant:'success'});
      })
    }
  }
}
</script>

<style scoped>
.dashwidget {
  background-color:#fff;
  float:left;
  margin: 10px;
}
</style>
